import React, {Fragment} from 'react';
import createForm from "./Form";
import ComponentField from "../../form/ComponentField";
import {CurrencyFormatter, UnitFormatter} from "../../../utils/formatters";
import {price, qty, vat} from "../../../utils/editors";
import {get, set} from "../../../utils/dotutils";
import DateTimeInput from "../../form/DateTimeInput";
import ImportButton from "../../form/ImportButton";
import classNames from "classnames";
import Button from "../../form/Button";
import Modal from "../../layout/Modal";
import isEqual from "lodash-es/isEqual";
import ComponentConfig from "../../form/ComponentConfig";
import ConsignmentReportList from "../lists/ConsignmentReportList";
import Tabs from "../../layout/Tabs";
import TabContent from "../../layout/TabContent";
import ComponentLoader from "../../form/ComponentLoader";
import ConsignmentReportForm from "./ConsignmentReportForm";
import RoyaltyReportList from "../lists/RoyaltyReportList";
import RoyaltyReportForm from "./RoyaltyReportForm";
import Select from "../../form/Select";
import {componentFilter} from "../../../utils/filters";
import { postData } from '../../../utils/request';

class RoyaltyPaymentForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            opened: false,
            changeConfirm: false,
            selectedRoyaltyReports: (this.props.values.xtradata || {}).reports || [],
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!isEqual((this.props.values.xtradata || {}).reports, (prevProps.values.xtradata || {}).reports)) {
            this.setState({
                selectedRoyaltyReports: (this.props.values.xtradata || {}).reports || [],
            });
        }
    }

    render() {
        const reports = this.props.context.partner.partner_id + "" !== "" + this.props.values.licensor?.partner_id && this.props.values.licensor?.partner_id && this.props.values.licensee?.partner_id;
        const date = this.props.stateConst.initiated > this.props.values.state;
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-md-2">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                        />
                    </div>
                    <div className={classNames({"col-md-5": !date, "col-md-4": date})}>
                        <div className="row">
                            <div className={classNames({"col-md-8": reports, "col-md-12": !reports})}>
                                <ComponentField
                                    getFieldProps={this.props.getFieldProps}
                                    componentConfig={this.props.componentConfig}
                                    name="licensor"
                                    labelKey="name"
                                    values={this.props.values}
                                    setFieldValue={this.props.setFieldValue}
                                    label="Jogtulajdonos"
                                />
                            </div>
                            {reports && <div className="col-md-4">
                                <label className="control-label">&nbsp;</label>
                                <Button
                                    color="primary"
                                    block={true}
                                    icon={{lib: "fa", name: "file-alt"}}
                                    tooltip="Riport(ok) kiválasztása"
                                    {...this.props.getFieldProps("riports")}
                                    onClick={() => {
                                        this.setState({opened: true});
                                    }}
                                />
                                <Fragment>
                                    <Modal
                                        header="Biztos?"
                                        state={this.state.changeConfirm}
                                        buttons={[
                                            {
                                                text: "Mégse",
                                                props: {color: "default", disabled: this.props.disabled || this.props.isLoading},
                                                onClose: true,
                                                onClick: async () => {
                                                    try {
                                                        this.setState({changeConfirm: false});
                                                    } catch (e) {

                                                    }
                                                }
                                            },
                                            {
                                                text: "Igen",
                                                props: {color: "warning", disabled: this.props.disabled || this.props.isLoading || isEqual(this.state.selectedRoyaltyReports, (this.props.values.xtradata || {}).reports || [])},
                                                onClick: async () => {
                                                    try {
                                                        await this.props.setSelectedReports(this.state.selectedRoyaltyReports);
                                                        this.setState({
                                                            selectedRoyaltyReports: this.state.selectedRoyaltyReports,
                                                            opened: false,
                                                            changeConfirm: false
                                                        }, () => {
                                                            this.pool && this.pool.refresh();
                                                        });
                                                    } catch (e) {
                                                        console.error(e);
                                                    }
                                                }
                                            }
                                        ]}
                                    >
                                        A kiválaszott riportok nem egyeznek az eddig kiválasztottakkal, ha elfogadod a tételek felül lesznek írva!<br/>
                                        Biztos ezt akarod?
                                    </Modal>
                                    <Modal
                                        header="Riport kiválasztása"
                                        state={this.state.opened}
                                        size={"large"}
                                        {...this.props}
                                        disabled={this.props.disabled || this.props.isLoading}
                                        buttons={[
                                            {
                                                text: "Mégse",
                                                props: {color: "default", disabled: this.props.disabled || this.props.isLoading},
                                                onClose: true,
                                                onClick: async () => {
                                                    try {
                                                        this.setState({selectedRoyaltyReports: (this.props.values.xtradata || {}).reports || [], opened: false, changeConfirm: false});
                                                    } catch (e) {

                                                    }
                                                }
                                            },
                                            {
                                                text: "Kiválasztás",
                                                props: {color: "primary", disabled: this.props.disabled || this.props.isLoading || isEqual(this.state.selectedRoyaltyReports, (this.props.values.xtradata || {}).reports || [])},
                                                onClick: async () => {
                                                    if (!(isEqual((this.props.values.xtradata || {}).reports, this.state.selectedRoyaltyReports) ||!(this.props.values.xtradata || {}).reports)) {
                                                        this.setState({changeConfirm: true});
                                                    } else {
                                                        try {
                                                            await this.props.setSelectedReports(this.state.selectedRoyaltyReports);
                                                            this.setState({
                                                                selectedRoyaltyReports: this.state.selectedRoyaltyReports,
                                                                opened: false,
                                                                changeConfirm: false
                                                            }, () => {
                                                                this.pool && this.pool.refresh();
                                                            });
                                                            this.pool && this.pool.refresh();
                                                        } catch (e) {
                                                            console.error(e);
                                                        }
                                                    }
                                                }
                                            }
                                        ]}
                                    >
                                        <div className="form-group">
                                            <label className="control-label">Riport(ok)</label>
                                            <ComponentConfig componentName="RoyaltyReport">
                                                <RoyaltyReportList
                                                    selection={this.state.selectedRoyaltyReports || []}
                                                    selectionMode="multiple"
                                                    actions={false}
                                                    filter={[{field: "licensor", value: this.props.values.licensor.licensor_id}]}
                                                    loadForm={(selectedRoyaltyReports) => {
                                                        if (selectedRoyaltyReports) {
                                                            this.setState({selectedRoyaltyReports: selectedRoyaltyReports.map((item) => item.id).sort((a,b) => a-b)});
                                                        } else {
                                                            this.setState({selectedRoyaltyReports: []});
                                                        }
                                                    }}
                                                />
                                            </ComponentConfig>
                                        </div>
                                        {
                                            this.state.selectedRoyaltyReports && !!this.state.selectedRoyaltyReports.length &&
                                            <div className="form-group">
                                                <Tabs
                                                    defaultTab={this.state.selectedRoyaltyReports[0]}
                                                    theme="default"
                                                >
                                                    {
                                                        this.state.selectedRoyaltyReports.map((reportId, idx) => {
                                                            return <TabContent
                                                                key={idx}
                                                                tabLabel={"#" + reportId + " Riport"}
                                                                tabName={reportId}
                                                            >
                                                                <ComponentConfig componentName="RoyaltyReport">
                                                                    <ComponentLoader
                                                                        componentName="RoyaltyReport"
                                                                        componentId={reportId}
                                                                        componentAs="values"
                                                                        view="admin"
                                                                    >
                                                                        <RoyaltyReportForm
                                                                            getFieldProps={() => ({disabled: true})}
                                                                        />
                                                                    </ComponentLoader>
                                                                </ComponentConfig>
                                                            </TabContent>;
                                                        })
                                                    }
                                                </Tabs>
                                            </div>
                                        }
                                    </Modal>
                                </Fragment>
                            </div>}
                        </div>
                    </div>
                    <div className={classNames({"col-md-5": !date, "col-md-4": date})}>
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="licensee"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Jogosult"
                        />
                    </div>
                    {date && <div className="col-md-2">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="payment_date"
                            fieldEditorType={DateTimeInput}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Dátum"
                        />
                    </div>}
                </div>
                <div className="row form-row">
                    <div className="col-sm-3">
                        <label className="control-label">Elszámolás dátuma</label>
                        <div className="input-group">
                            <DateTimeInput
                                {...this.props.getFieldProps("transaction_date")}
                                name="transaction_date"
                                value={this.props.values.transaction_date}
                                showTime={false}
                                disabled={this.props.isLoading}
                                saveChanges={this.props.setFieldValue}
                                label={false}
                            />
                            <div className="input-group-btn">
                                <Button
                                    color={this.props.values.transaction_date === this.props.initialValues.transaction_date ? "default" : "primary"}
                                    disabled={this.props.values.transaction_date === this.props.initialValues.transaction_date || this.props.isLoading}
                                    onClick={async () => {
                                        await this.props.processAction(async () => {
                                            return await postData({
                                                action: this.props.componentConfig.componentname + '.update',
                                                data: {
                                                    [this.props.componentConfig.idfield]: this.props.values[this.props.componentConfig.idfield],
                                                    transaction_date: this.props.values.transaction_date
                                                }
                                            });
                                        });
                                    }}>
                                    Mentés
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                {this.props.values[this.props.componentConfig.idfield] && this.props.values.licensor && this.props.values.licensee && <Fragment>
                    <div className="row form-row">
                        <div className="col-sm-12">
                            <Select
                                disabled={this.props.isLoading}
                                value={(this.props.values.xtradata || {}).vat}
                                label="Áfa"
                                component="vatrate"
                                isClearable={true}
                                storeType="local"
                                objectValue={false}
                                {...this.props.getFieldProps("vat")}
                                saveChanges={(field, vat) => this.props.setFieldValue("xtradata.vat", vat)}
                            />
                        </div>
                    </div>
                    <div className="row form-row">
                        <div className="col-sm-12">
                            <ComponentField
                                getFieldProps={this.props.getFieldProps}
                                componentConfig={this.props.componentConfig}
                                addRow={((this.props.values.xtradata || {}).reports || []).length || this.props.dirty ? false : undefined}
                                addButton={((this.props.values.xtradata || {}).reports || []).length || this.props.dirty ? false : undefined}
                                addRowProps={{
                                    component: "Royalty",
                                    labelKey: "object_component.displayname",
                                    filter: [
                                        {field: "licensor", value: this.props.values.licensor.licensor_id},
                                        {field: "licensee", value: this.props.values.licensee.partner_id}
                                    ]
                                }}
                                name="items"
                                onItemUpdate={async (newData, oldData, fieldName, rowIndex, props) => {
                                    const data = {
                                        [props.listfieldComponentConfig.idfield]: newData[props.listfieldComponentConfig.idfield]
                                    };
                                    set(data, fieldName, get(newData, fieldName));
                                    return await props.updateItem(data);
                                }}
                                columns={{
                                    "id": {
                                        header: 'Kód',
                                        width: 1,
                                        sortable: true,
                                        filterable: true
                                    },
                                    "royalty.object_component.displayname": {
                                        header: 'Megnevezés',
                                        width: 7,
                                        sortable: true,
                                        filterable: true
                                    },
                                    "baseprice": {
                                        header: 'Alap',
                                        width: 1,
                                        sortable: true,
                                        filterable: true,
                                        renderer: CurrencyFormatter,
                                    },
                                    "amount": {
                                        header: 'Nettó egységár',
                                        width: 1,
                                        sortable: true,
                                        filterable: true,
                                        className: "currency",
                                        renderer: CurrencyFormatter,
                                        editor: price({field: "amount"})
                                    },
                                    "qty": {
                                        header: 'Darabszám',
                                        width: 1,
                                        sortable: true,
                                        filterable: true,
                                        className: "unit",
                                        renderer: (value, row) => UnitFormatter(value, row.unit),
                                        editor: qty()
                                    },
                                    "amount_net_total": {
                                        header: 'Nettó összeg',
                                        width: 1,
                                        sortable: true,
                                        filterable: true,
                                        className: "currency",
                                        renderer: CurrencyFormatter,
                                        editor: price({field: "amount_net_total"})
                                    },
                                    "vat": {
                                        header: 'Áfa',
                                        className: 'nowrap',
                                        width: "vat",
                                        sortable: true,
                                        filterable: componentFilter({component: "vatrate"}),
                                        renderer: (value) => <span className="vat">{(value || {}).name}</span>,
                                        editor: vat()
                                    },
                                    "amount_gross_total": {
                                        header: 'Bruttó összeg',
                                        width: 1,
                                        sortable: true,
                                        filterable: true,
                                        className: "currency",
                                        renderer: CurrencyFormatter,
                                    }
                                }}
                                aggregations={{
                                    fields: {
                                        "qty": {
                                            type: "SUM"
                                        },
                                        "amount": {
                                            type: "SUM"
                                        },
                                        "amount_net_total": {
                                            type: "SUM"
                                        },
                                        "amount_gross_total": {
                                            type: "SUM"
                                        }
                                    }
                                }}
                                values={this.props.values}
                                setFieldValue={this.props.setFieldValue}
                                label="Tételek"
                            />
                        </div>
                    </div>
                </Fragment>}
            </form>
        );
    }
}

export default createForm(RoyaltyPaymentForm);
